import React from "react";

/**
 * LungsIcon — Phosphor-style custom SVG for EGA arterioso.
 * Uses currentColor + inherits fontSize via `size` prop like Phosphor icons.
 * Props are Phosphor-compatible: size, weight ("regular"|"fill"|"bold"), color, className.
 */
export default function LungsIcon({ size = 20, weight = "regular", color, className }) {
  const stroke = color || "currentColor";
  const fill = weight === "fill" ? stroke : "none";
  const opacity = weight === "fill" ? 0.18 : 1;
  const sw = weight === "bold" ? 20 : 16;
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 256 256"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-hidden="true"
    >
      {/* Trachea */}
      <path
        d="M128 32 L128 116"
        stroke={stroke}
        strokeWidth={sw}
        strokeLinecap="round"
        fill="none"
      />
      {/* Left lung */}
      <path
        d="M120 116
           C 120 108, 108 100, 92 100
           C 60 100, 32 132, 32 176
           C 32 200, 44 216, 62 216
           C 90 216, 120 196, 120 168
           Z"
        stroke={stroke}
        strokeWidth={sw}
        strokeLinejoin="round"
        strokeLinecap="round"
        fill={fill}
        fillOpacity={opacity}
      />
      {/* Right lung */}
      <path
        d="M136 116
           C 136 108, 148 100, 164 100
           C 196 100, 224 132, 224 176
           C 224 200, 212 216, 194 216
           C 166 216, 136 196, 136 168
           Z"
        stroke={stroke}
        strokeWidth={sw}
        strokeLinejoin="round"
        strokeLinecap="round"
        fill={fill}
        fillOpacity={opacity}
      />
      {/* Bronchi hint - short lines from trachea into each lung */}
      <path
        d="M128 116 L108 124 M128 116 L148 124"
        stroke={stroke}
        strokeWidth={weight === "bold" ? 14 : 10}
        strokeLinecap="round"
        fill="none"
      />
    </svg>
  );
}
